import { LobbyCodePage } from '@hendrx/core/plenary/pages/LobbyCodePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lobby/')({
  component: LobbyCodePage
});
